
export enum LocalStorageKeys {
    SearchedCompanyExplainability = "searched_company_explainability",
    SearchedCompanies = "searched_companies",
    SearchedCampaigns = "searched_campaigns",
    SearchedVendors = "searched_vendors",
    SearchedAffiliates= "searched_Affiliates"
}